<template>
	<div class="pb-6 py-24 md2:pt-20">
		<div class="flex w-full justify-center">
			<div class="w-full">
				<!-- Header Section -->
				<div class="flex w-full justify-center text-ihh-midnight-gray font-semibold text-3xl text-center tracking-wide">Gift Certificates</div>

				<!-- Buttons Section -->
				<div class="my-12" id="details">
					<div class="flex w-full justify-center px-3">
						<div class="flex flex-col sm:flex-row w-full max-w-3xl md2:max-w-3xl gap-4">
							<button
								v-for="button in buttons"
								:key="button.key"
								@click="setActive(button.key)"
								:class="[
									'text-center flex w-full justify-center text-base tracking-wide',
									activeSection === button.key
										? 'underline underline-offset-8 decoration-ihh-midnight-gray decoration-1 text-ihh-slate-gray font-semibold'
										: 'text-ihh-slate-gray',
								]"
							>
								{{ button.label }}
							</button>
						</div>
					</div>
				</div>

				<!-- Purchase Gift Certificate Section -->
				<div class="flex w-full justify-center">
					<div v-if="activeSection === 'purchaseGiftCertificate'" class="w-full max-w-2xl border-t lg:max-w-3xl p-6">
						<div class="flex flex-col w-full justify-center">
							<div class="flex w-full justify-center items-center mb-8">
								<img src="/images/gift-certificate-logo.png" class="flex w-full max-w-sm md:max-w-md" />
							</div>
							<form @submit.prevent="addToCart">
								<div class="gap-5 grid grid-cols-1 sm:grid-cols-2">
									<div class="w-full sm:col-span-1">
										<label for="yourName" class="block text-ihh-slate-gray text-xs sm:text-sm mb-1 flex w-full">
											<span class="flex w-full justify-start text-start font-semibold">Your Name</span>
											<span class="flex w-full justify-end m-auto text-end uppercase text-xs sm:text-sm font-semibold text-ihh-slate-gray/90"
												>Required</span
											>
										</label>
										<input
											type="text"
											id="yourName"
											v-model="certificate.sender.name"
											required
											class="border border-ihh-gray placeholder-ihh-gray text-ihh-midnight-gray focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon rounded px-2 sm:px-2 py-3 flex w-full text-sm bg-white"
										/>
									</div>
									<div class="w-full">
										<label for="yourEmail" class="block text-ihh-slate-gray text-xs sm:text-sm mb-1 flex w-full">
											<span class="flex w-full justify-start text-start font-semibold">Your Email</span>
											<span class="flex w-full justify-end m-auto text-end uppercase text-xs sm:text-sm font-semibold text-ihh-slate-gray/90"
												>Required</span
											>
										</label>
										<input
											type="text"
											id="yourEmail"
											v-model="certificate.sender.email"
											required
											class="border border-ihh-gray placeholder-ihh-gray text-ihh-midnight-gray focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon rounded px-2 sm:px-2 py-3 flex w-full text-sm bg-white"
										/>
									</div>
									<div class="w-full">
										<label for="recipientName" class="block text-ihh-slate-gray text-xs sm:text-sm mb-1 flex w-full">
											<span class="flex w-full justify-start text-start font-semibold">Recipient's Name</span>
											<span class="flex w-full justify-end m-auto text-end uppercase text-xs sm:text-sm font-semibold text-ihh-slate-gray/90"
												>Required</span
											>
										</label>
										<input
											type="text"
											id="recipientName"
											v-model="certificate.recipient.name"
											required
											placeholder="Recipients Full Name"
											class="border border-ihh-gray placeholder-ihh-gray text-ihh-midnight-gray focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon rounded px-2 sm:px-2 py-3 flex w-full text-sm bg-white"
										/>
									</div>
									<div class="w-full">
										<label for="recipientEmail" class="block text-ihh-slate-gray text-xs sm:text-sm mb-1 flex w-full">
											<span class="flex w-full justify-start text-start font-semibold">Recipient's Email</span>
											<span class="flex w-full justify-end m-auto text-end uppercase text-xs sm:text-sm font-semibold text-ihh-slate-gray/90"
												>Required</span
											>
										</label>
										<input
											type="text"
											id="recipientEmail"
											v-model="certificate.recipient.email"
											required
											placeholder="recipientsemail@gmail.com"
											class="border border-ihh-gray placeholder-ihh-gray text-ihh-midnight-gray focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon rounded px-2 sm:px-2 py-3 flex w-full text-sm bg-white"
										/>
									</div>

									<div v-if="selectedAmount !== 'Other'" class="w-full sm:col-span-1">
										<label for="amount" class="block text-ihh-slate-gray text-xs sm:text-sm mb-1 flex w-full">
											<span class="flex w-full justify-start text-start font-semibold">Amount</span>
											<span class="flex w-full justify-end m-auto text-end uppercase text-xs sm:text-sm font-semibold text-ihh-slate-gray/90"
												>Required</span
											>
										</label>
										<select
											id="amount"
											v-model="selectedAmount"
											@change="handleAmountSelect"
											class="border border-ihh-gray placeholder-ihh-gray focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon rounded px-2 py-3 flex w-full bg-white text-base text-ihh-slate-gray font-thin"
										>
											<option value="Select Amount" selected disabled class="deselect">Select Amount</option>
											<option v-for="(amount, index) in amounts" :key="index" :value="amount">
												{{ amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
											</option>
										</select>
									</div>

									<div v-else>
										<label for="custom-amount" class="block text-ihh-slate-gray text-xs sm:text-sm mb-1 flex w-full">
											<span class="flex w-full justify-start text-start font-semibold">Amount</span>
											<span class="flex w-full justify-end m-auto text-end uppercase text-xs sm:text-sm font-semibold text-ihh-slate-gray/90"
												>Required</span
											>
										</label>
										<div class="relative">
											<span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-ihh-slate-gray">$</span>
											<input
												type="text"
												id="custom-amount"
												v-model="customAmount"
												required
												placeholder="25.00"
												@input="handleCustomInput"
												class="border border-ihh-gray placeholder-ihh-gray focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon rounded pr-2 py-3 pl-6 flex w-full bg-white text-base text-ihh-slate-gray font-thin"
											/>
										</div>
										<div v-if="customAmountError" class="text-xs text-ihh-dark-salmon mt-1">
											{{ customAmountError }}
										</div>
									</div>

									<div class="w-full sm:col-span-1">
										<label for="theme" class="block text-ihh-slate-gray text-xs sm:text-sm mb-1 flex w-full">
											<span class="flex w-full justify-start text-start font-semibold">Gift Certificate Theme</span>
											<span class="flex w-full justify-end m-auto text-end uppercase text-xs sm:text-sm font-semibold text-ihh-slate-gray/90"
												>Required</span
											>
										</label>
										<select
											id="theme"
											v-model="certificate.theme"
											class="border border-ihh-gray placeholder-ihh-gray text-ihh-midnight-gray focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon rounded px-2 py-3 flex w-full bg-white text-base font-thin"
										>
											<option v-for="(theme, index) in themes" :key="index" :value="theme">{{ theme }}</option>
										</select>
									</div>

									<div class="w-full sm:col-span-2">
										<div class="w-full">
											<label for="review" class="block font-semibold text-ihh-slate-gray text-xs sm:text-sm mb-1 text-start">Optional Message</label>
											<textarea
												type="text"
												id="review"
												v-model="certificate.message"
												required
												placeholder="Add Message with Gift Certificate..."
												class="w-full h-full max-h-80 min-h-40 border border-ihh-gray placeholder-ihh-gray text-ihh-midnight-gray focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon rounded px-2 py-3 sm:py-4 flex text-sm bg-white"
											/>
										</div>
									</div>

									<div class="m-auto items-center flex w-full">
										<div class="flex items-center m-auto w-full pr-4">
											<label
												class="custom-checkbox relative inline-block overflow-hidden w-4 min-w-4 max-w-4 h-4 min-h-4 max-h-4 bg-transparent rounded border border-ihh-gray cursor-pointer mr-4 sm:mr-2"
											>
												<input type="checkbox" v-model="noRefundTermsAccepted" class="absolute opacity-0 w-0 h-0" />
												<span class="checkmark absolute inset-0 flex items-center justify-center text-ihh-white/90 text-lg"> ✓ </span>
											</label>
											<div class="text-ihh-slate-gray text-sm whitespace-nowrap sm:whitespace-normal sm:text-base items-center text-start">
												I agree that Gift Certificates are nonrefundable
											</div>
										</div>
									</div>

									<div class="drop-shadow-2xl text-center flex w-full justify-start sm:justify-end sm:col-span-1">
										<button
											@click.prevent="addToCart"
											type="submit"
											value="Submit"
											:class="{ 'opacity-40 pointer-events-none': !noRefundTermsAccepted || !validAmount }"
											class="text-center text-sm sm:text-base text-ihh-midnight-gray px-8 py-3 rounded-lg bg-ihh-dark-salmon hover:bg-ihh-salmon duration-100 whitespace-nowrap font-semibold"
										>
											Add Gift Certificate to Bag
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					<!-- Redeem Gift Certificate Section -->
					<div v-if="activeSection === 'redeemGiftCertificate'" class="w-full max-w-2xl border-t space-y-5 p-6">
						<div class="text-start text-ihh-gray-600 font-normal text-base">
							<div class="space-y-4">
								<div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-2xl text-start tracking-wide">Redeem Gift Certificate</div>
								<div class="font-semibold">To redeem a gift certificate at In His Hands Birth Supply, follow the simple steps below.</div>
								<ul class="list-decimal pl-6 leading-8">
									<li>
										You need your unique gift certificate code, which is part of the gift certificate that was emailed to you as an attachment. It will
										look something like Z50-Y6K-COS-402.
									</li>
									<li>Browse the store and add items to your bag as you normally would.</li>
									<li>
										Click the
										<a href="/checkout" class="text-ihh-dark-salmon hover:text-ihh-salmon underline underline-offset-2 font-semibold">'View Bag'</a> link
										to view the contents of your shopping bag.
									</li>
									<li>Type your gift certificate code into the 'Redeem Gift Certificate' box and click 'Go'.</li>
								</ul>
							</div>
						</div>
					</div>

					<!-- Check Gift Certificate Balance Section -->
					<div v-if="activeSection === 'checkGiftCertificateBalance'" class="w-full max-w-2xl border-t space-y-5 p-6">
						<div class="text-start text-ihh-gray-600 font-normal text-sm md2:text-xxs">
							<div class="space-y-4">
								<div class="flex w-full justify-start text-ihh-midnight-gray font-semibold text-2xl text-start tracking-wide">
									Check Gift Certificate Balance
								</div>
								<div class="text-base text-ihh-gray-600 font-semibold">
									You can check the balance of a gift certificate by typing the code into the box below.
								</div>
								<div v-if="!checkedCertificate.amount" class="space-y-4">
									<div class="relative w-full">
										<div class="text-sm text-ihh-gray-600 font-semibold mb-2">Gift Certificate Code:</div>
										<input
											type="text"
											v-model="checkedCertificate.code"
											required
											class="py-3 pl-4 flex border border-ihh-gray-600 rounded w-full text-sm md:text-base bg-white font-light text-black placeholder-ihh-gray relative focus:border-ihh-dark-salmon focus:outline-0 focus:shadow shadow-ihh-dark-salmon"
										/>
									</div>
									<button
										@click="checkBalance(checkedCertificate.code)"
										class="flex w-full justify-center text-center text-sm md:text-base font-semibold text-ihh-midnight-gray py-3 px-10 rounded-lg bg-ihh-dark-salmon hover:bg-ihh-salmon duration-200 transition tracking-wide"
									>
										Check Balance
									</button>
								</div>
								<div v-if="checkedCertificate.amount" id="certificateResults" class="mt-6 border border-ihh-gray-300 rounded-lg p-4 bg-white shadow-sm">
									<div class="flex justify-between items-center mb-4">
										<h3 class="text-lg font-semibold text-ihh-midnight-gray">Gift Certificate Details</h3>
										<button
											@click="checkedCertificate = { amount: null, balance: null, code: '' }"
											class="text-xs text-ihh-dark-salmon hover:text-ihh-salmon font-medium transition duration-200"
										>
											Check Another
										</button>
									</div>
									<div class="space-y-3">
										<div class="flex justify-between items-center py-2 border-b border-ihh-gray-200">
											<span class="text-ihh-slate-gray font-medium">Original Amount:</span>
											<span class="text-ihh-midnight-gray font-semibold">{{
												checkedCertificate?.amount?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
											}}</span>
										</div>
										<div class="flex justify-between items-center py-2">
											<span class="text-ihh-slate-gray font-medium">Current Balance:</span>
											<span class="text-ihh-midnight-gray font-semibold">{{
												checkedCertificate?.balance?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
											}}</span>
										</div>
										<div v-if="checkedCertificate?.amount !== checkedCertificate?.balance" class="text-xs text-ihh-slate-gray italic mt-1">
											<span v-if="checkedCertificate?.balance > 0 && checkedCertificate?.balance < checkedCertificate?.amount">
												This certificate has been partially redeemed.
											</span>
											<span v-else-if="checkedCertificate?.balance <= 0" class="text-ihh-dark-salmon"> This certificate has been fully redeemed. </span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<!-- Vue Component Script -->
<script>
import Swal from 'sweetalert2'
import axios from 'axios'
import confetti from 'canvas-confetti'

export default {
	inject: ['store'],
	data() {
		return {
			terms: false,
			activeSection: '',
			buttons: [
				{ key: 'purchaseGiftCertificate', label: 'Purchase Gift Certificate' },
				{ key: 'redeemGiftCertificate', label: 'Redeem Gift Certificate' },
				{ key: 'checkGiftCertificateBalance', label: 'Check Gift Certificate Balance' },
			],
			currentIndex: 0,
			noRefundTermsAccepted: false,
			selectedQuantity: 1,
			activeSection: 'purchaseGiftCertificate',
			amounts: [25, 50, 100, 200, 'Other'],
			customAmount: '',
			customAmountError: '',
			formattedCustomAmount: '',
			debounceTimer: null,
			selectedAmount: 'Select Amount',
			certificate: {
				name: 'A Gift For You',
				theme: '',
				amount: '',
				quantity: 1,
				sender: {
					name: '',
					email: '',
				},
				recipient: {
					name: '',
					email: '',
				},
				message: '',
			},
			checkedCertificate: {
				amount: null,
				balance: null,
				code: '',
			},
			themes: ['Birthday', 'Boy', 'Girl', 'Celebration', 'Christmas', 'General'],
		}
	},

	mounted() {
		this.certificate.sender.name = this.store?.user?.id ? this.store.user.firstName + ' ' + this.store.user.lastName : ''
		this.certificate.sender.email = this.store?.user?.id ? this.store.user.email : ''

		// Check if URL has action=redeem query parameter and set activeSection accordingly
		const urlParams = new URLSearchParams(window.location.search)
		if (urlParams.get('action') === 'redeem') {
			this.activeSection = 'redeemGiftCertificate'
		}
	},
	methods: {
		setActive(section) {
			this.activeSection = section
			this.checkedCertificate = {
				amount: null,
				balance: null,
				code: this.checkedCertificate.code || '',
			}
		},
		resetCertificate() {
			this.customAmount = ''
			this.customAmountError = ''
			this.formattedCustomAmount = ''
			this.selectedAmount = 'Select Amount'

			this.certificate = {
				name: 'A Gift For You',
				theme: '',
				amount: '',
				quantity: 1,
				sender: {
					name: this.store?.user?.id ? this.store.user.firstName + ' ' + this.store.user.lastName : '',
					email: this.store?.user?.id ? this.store.user.email : '',
				},
				recipient: {
					name: '',
					email: '',
				},
				message: '',
			}
		},
		addToCart() {
			let missingFields = this.validateFields()

			if (missingFields.length) {
				return Swal.fire({
					icon: 'error',
					title: 'Required Fields Missing',
					text: `Please provide input for the following fields: ${missingFields.join(', ')}`,
					confirmButtonText: 'OK',
				})
			}

			event.preventDefault()

			console.log('Adding certificate to cart')
			if (this.store?.cart?.certificates?.length) {
				console.log('Cart has certificates')
				this.store.cart.certificates.push(this.certificate)
			} else {
				console.log('Adding certificate to cart')
				this.store.cart.certificates = []
				this.store.cart.certificates.push(this.certificate)
			}
			this.resetCertificate()
			this.store.showBag = true
		},
		validateFields() {
			const fields = [
				{ field: this.certificate.sender.name, name: 'Sender Name' },
				{ field: this.certificate.sender.email, name: 'Sender Email' },
				{ field: this.certificate.recipient.name, name: 'Recipient Name' },
				{ field: this.certificate.recipient.email, name: 'Recipient Email' },
				{ field: this.certificate.amount, name: 'Amount' },
				{ field: this.certificate.theme, name: 'Certificate Theme' },
			]

			return fields.filter((f) => !f.field).map((f) => f.name)
		},
		handleAmountSelect() {
			// If a predefined amount is selected (not 'Other' and not the placeholder)
			if (this.selectedAmount !== 'Other' && this.selectedAmount !== 'Select Amount') {
				// Set the certificate amount to the selected value
				this.certificate.amount = this.selectedAmount
			} else {
				// Clear the certificate amount if the placeholder is selected
				this.certificate.amount = ''
			}
			// If 'Other' is selected, the handleCustomInput method will handle setting the amount
		},
		handleCustomInput(event) {
			// Clear any existing debounce timer
			if (this.debounceTimer) clearTimeout(this.debounceTimer)

			// Get the raw input value
			let inputValue = this.customAmount.toString()

			// Remove any non-digit characters except for decimal point
			inputValue = inputValue.replace(/[^0-9.]/g, '')

			// Ensure only one decimal point
			const parts = inputValue.split('.')
			if (parts.length > 2) {
				inputValue = parts[0] + '.' + parts.slice(1).join('')
			}

			// Limit to two decimal places
			if (parts.length > 1 && parts[1].length > 2) {
				inputValue = parts[0] + '.' + parts[1].substring(0, 2)
			}

			// Update the custom amount with the sanitized input
			this.customAmount = inputValue

			// Set a debounce timer to avoid rapid processing
			this.debounceTimer = setTimeout(() => {
				// Parse the input value as a float
				let value = parseFloat(inputValue)

				// Check if the value is a valid number
				if (!isNaN(value)) {
					// Check if the amount is less than $25
					if (value < 25) {
						this.customAmountError = 'Amount must be at least $25.00'
						this.certificate.amount = ''
					} else {
						// Clear any error message
						this.customAmountError = ''

						// Format the value with 2 decimal places
						value = parseFloat(value.toFixed(2))

						// Format for display (we keep the raw value in customAmount for editing)
						this.formattedCustomAmount = value.toLocaleString('en-US', {
							style: 'currency',
							currency: 'USD',
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						})

						// Set the certificate amount
						this.certificate.amount = value
					}
				} else {
					// If not a valid number, clear the certificate amount
					this.certificate.amount = ''
					this.customAmountError = inputValue ? 'Please enter a valid amount' : ''
				}
			}, 300)
		},
		async checkBalance(code) {
			const response = await axios.get(`${this.store.api}/controllers/bigCommerce/certificates/${code}`)
			if (!response.data.success && response.data.message) {
				Swal.fire({
					icon: 'error',
					title: 'Invalid Gift Certificate Code',
					text: response.data.message,
					confirmButtonText: 'OK',
				})
			} else if (!response?.data?.success && !response?.data?.message) {
				Swal.fire({
					icon: 'error',
					title: 'Error Checking Gift Certificate Balance',
					text: 'Error validating the provided gift certificate code.',
					confirmButtonText: 'OK',
				})
			}

			this.checkedCertificate.balance = response.data.balance
			this.checkedCertificate.amount = response.data.amount

			// Show confetti if the certificate has a positive balance
			if (response.data.balance > 0) {
				this.$nextTick(() => {
					confetti({
						particleCount: 100,
						spread: 70,
						origin: { y: 0.6 },
						colors: ['#F3C4B4', '#D6A69A', '#4C5760', '#293132', '#F26A4F'],
						zIndex: 1000,
					})
				})
			}
		},
	},
	computed: {
		validAmount() {
			return this.certificate.amount >= 25
		},
	},
}
</script>
